import { useEffect } from 'react';
import { GroupElement } from '@bynder-studio/render-core';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import useEditor from '~/hooks/useEditor';
import { useIsModalOpen } from '~/hooks/useIsModalOpen';

type Props = {
    id: number;
    callback: () => void;
};

export default function useElementRenameShortcuts({ id, callback }: Props) {
    const { manipulationRenderer } = useEditor();
    const isModalOpen = useIsModalOpen();

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!manipulationRenderer || isModalOpen) {
                return;
            }

            if (isCtrlKey(event) && event.shiftKey && event.code === 'KeyR') {
                event.preventDefault();

                const selectedElements = manipulationRenderer.getSelectedElements();
                const selectionContainsGroup = selectedElements.some((el) => el instanceof GroupElement);

                if (
                    selectedElements.length === 0 ||
                    (selectedElements.length > 1 && !selectionContainsGroup) ||
                    selectedElements[0].id !== id
                ) {
                    return;
                }

                callback();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [manipulationRenderer, isModalOpen]);
}
